import { exchangeToken } from "./exchangeToken";
import type { ExchangeTokenParams, ExchangeTokenResponse } from "./types";
import { ContextManager } from "~/modules/contextManager/ContextManager";

export const exchangeTokenWrapper = async (options: ExchangeTokenParams): Promise<ExchangeTokenResponse> => {
    return exchangeToken(ContextManager.newInstance())(options);
};
